import { Component,Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ProfileModel } from 'src/app/models/profile.model';
import { DataService } from 'src/app/services/data/data.service';
import { NavController, AlertController } from '@ionic/angular';
import { MathService } from 'src/app/services/math/math.service';

@Component({
  selector: 'profiles-list',
  templateUrl: './profiles-list.component.html',
  styleUrls: ['./profiles-list.component.scss'],
})
export class ProfilesListComponent implements OnInit {

  @Input()
  title:string;

  @Input()
  subtitle:string;

  @Input()
  role:string;

  @Input()
  mode:string // edit, view, order, catalog, sale, prepare

  @Input()
  loading:boolean = false;

  @Input()
  items:ProfileModel[];

  @Input()
  sortBy:string

  @Input()
  owner:ProfileModel;

  @Output() profileClicked = new EventEmitter<ProfileModel>();

  @Input()
  public onProfileClicked = (profile:ProfileModel) => {};

  constructor(private dataService:DataService, private navCtrl:NavController, private alertCtrl:AlertController, private mathService:MathService) {

  }

  ngOnInit(){

  }

  public edit(item:ProfileModel){
    this.navCtrl.navigateForward('/producer/'+ this.owner.key+'/reseller/'+item.key+'/edit');
  }

  public add(){
    this.navCtrl.navigateForward('/producer/'+ this.owner.key+'/reseller/new');
  }

  publish(item:ProfileModel){
    this.changeResellerStatus(item,'published');
  }

  unpublish(item:ProfileModel){
    this.changeResellerStatus(item,'unpublished');
  }

  async changeResellerStatus(item:ProfileModel,status){
    console.log(item);
    item.status = status;
    this.dataService.updateProducerResellerStatus(item);
  } 

  // async deleteReseller(item,i){
  //     const alert = await this.alertCtrl.create({
  //       header:'Supprimer',
  //       message:'Voulez-vous vraimer supprimer ce produit?',
  //       buttons:[{
  //         text: 'Non',
  //         handler: data => {
  //           //alert.dismiss();
  //         }
  //       },
  //     {
  //       text: 'Oui',
  //       handler: data => {
  //         //alert.dismiss();
  //         this.dataService.deleteProduct(item).then(_=>{
  //           this.items.splice(i,1);
  //         });
  //       }
  //     }]
  //     });
  //     await alert.present();
  // }

  clickItem(item:ProfileModel){
    if(this.mode =='select'){
      console.log('click', item);
      this.profileClicked.emit(item);
      this.onProfileClicked(item);
    }
  }
}
